import {
  GET_OFFERSTATUS_LISTING,
  GET_OFFERSTATUS_LISTING_SUCCESS,
  GET_OFFERSTATUS_LISTING_FAILED,
  FETCH_OFFER_STATUS_BY_SECTION,
  FETCH_OFFER_STATUS_BY_SECTION_SUCCESS,
  FETCH_OFFER_STATUS_BY_SECTION_FAIL,
  ADD_OFFER_STATUS,
  ADD_OFFER_STATUS_SUCCESS,
  ADD_OFFER_STATUS_FAIL,
  EDIT_OFFER_STATUS,
  EDIT_OFFER_STATUS_SUCCESS,
  EDIT_OFFER_STATUS_FAIL,
  UPDATE_OFFER_STATUS,
  UPDATE_OFFER_STATUS_SUCCESS,
  UPDATE_OFFER_STATUS_FAIL,
  OFFER_STATUS_ACTIVE_INACTIVE,
  OFFER_STATUS_ACTIVE_INACTIVE_SUCCESS,
  OFFER_STATUS_ACTIVE_INACTIVE_FAIL,
  OFFER_STATUS_POSITION,
  OFFER_STATUS_POSITION_SUCCESS,
  OFFER_STATUS_POSITION_FAIL,
} from "./actionTypes"

const initialState = {
  loading: false,
  offerStatus: [],
  error: null,
  msg: null,
  positionUpdate: null,
}

const offerStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFERSTATUS_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        positionUpdate: null,
        offerStatus: action.payload,
      }
      break
    case GET_OFFERSTATUS_LISTING_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        positionUpdate: null,
        offerStatus: action.payload,
      }
      break
    case GET_OFFERSTATUS_LISTING_FAILED:
      state = { ...state, loading: false }
      break
    case FETCH_OFFER_STATUS_BY_SECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        positionUpdate: null,
        offerStatusList: action.payload,
      }
      break
    case FETCH_OFFER_STATUS_BY_SECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        positionUpdate: null,
        offerStatus: action.payload,
      }
      break
    case FETCH_OFFER_STATUS_BY_SECTION_FAIL:
      state = {
        ...state,
        msg: null,
        positionUpdate: null,
        loading: false,
      }
      break
    case ADD_OFFER_STATUS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offerStatus: action.payload,
        offerStatusEdit: null,
      }
      break
    case ADD_OFFER_STATUS_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        offerStatus: action.payload,
      }
      break
    case ADD_OFFER_STATUS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload ? action.payload : null,
      }
      break
    case EDIT_OFFER_STATUS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offerStatusEdit: action.payload,
      }
      break
    case EDIT_OFFER_STATUS_SUCCESS:
      if (state === null || state.offerStatus.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offerStatus: [...state.offerStatus, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          offerStatus: state.offerStatus.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
      }
      break
    case EDIT_OFFER_STATUS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break
    case UPDATE_OFFER_STATUS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offerStatus: action.payload,
      }
      break
    case UPDATE_OFFER_STATUS_SUCCESS:
      state = { ...state, error: null, msg: null, loading: false }
      break
    case UPDATE_OFFER_STATUS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break

    case OFFER_STATUS_ACTIVE_INACTIVE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
      }
      break

    case OFFER_STATUS_ACTIVE_INACTIVE_SUCCESS:
      const index = state.offerStatus.findIndex(
        offerStatus => offerStatus.offer_status_id === action.payload.id
      )
      let offerStatusStatus = []
      offerStatusStatus = [...state.offerStatus] //making a new array
      offerStatusStatus[index].status =
        offerStatusStatus[index].status == 1 ? 0 : 1

      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        offerStatus: offerStatusStatus,
      }
      break

    case OFFER_STATUS_ACTIVE_INACTIVE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error:
          action.payload !== "light"
            ? action.payload
            : "" !== "light"
            ? action.payload
            : "",
      }
      break
    case OFFER_STATUS_POSITION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        positionUpdate: null,
      }
      break
    case OFFER_STATUS_POSITION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: action.payload.msg != "" ? action.payload.msg : "",
        positionUpdate: true,
      }
      break
    case OFFER_STATUS_POSITION_FAIL:
      state = {
        ...state,
        loading: false,
        error: action.payload.msg != "" ? action.payload.msg : "",
        msg: null,
        positionUpdate: null,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default offerStatus
